import * as Sentry from '@sentry/react';

// Sentry 配置
export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.warn('Sentry DSN not found, error tracking disabled');
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      // 性能監控
      Sentry.browserTracingIntegration(),
      // 重播功能（可選）
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // 性能監控配置
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 0.2, // 生產 10%；開發略降，減少噪音

    // 重播：開發全量採樣易觸發 Sentry 429；生產亦維持低採樣
    replaysSessionSampleRate: import.meta.env.PROD ? 0.05 : 0,
    replaysOnErrorSampleRate: import.meta.env.PROD ? 0.2 : 0,

    // 錯誤監控
    beforeSend(event) {
      // 可以添加自定義錯誤過濾邏輯
      console.log('Sentry error captured:', event);
      return event;
    },

    // 性能監控
    beforeSendTransaction(event) {
      // 可以添加自定義性能過濾邏輯
      return event;
    },
  });

  console.log('✅ Sentry initialized');
};

// 自定義錯誤報告函數
export const captureException = (error: Error, context?: Record<string, any>) => {
  Sentry.captureException(error, {
    tags: {
      component: 'frontend',
    },
    extra: context,
  });
};

// 自定義訊息報告函數
export const captureMessage = (message: string, level: Sentry.SeverityLevel = 'info', context?: Record<string, any>) => {
  Sentry.captureMessage(message, level, {
    tags: {
      component: 'frontend',
    },
    extra: context,
  });
};

// 用戶信息設置
export const setUser = (user: { id: string; email?: string; username?: string }) => {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.username,
  });
};

// 用戶信息清除
export const clearUser = () => {
  Sentry.setUser(null);
};

// 性能監控（Sentry v8+ 已不再建議使用 startTransaction；如需手動 span/transaction，請在需要時再引入對應 API）

export { Sentry };
